import { WorkerSummaryReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the summary reports for the given data.
 * @example
 * ```html
 * <salaxy-worker-summary-report data="$ctrl.data"></salaxy-worker-summary-report>
 * ```
 */
export class WorkerSummaryReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The data for the report. */
      data: "<"
    };

    /** Uses the WorkerSummaryReportController */
    public controller = WorkerSummaryReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/WorkerSummaryReport.html";

}
